'use client';

import { useState, type FormEvent } from 'react';
import Link from 'next/link';
import { useRouter } from 'next/navigation';
import { AuthLayout } from '@/components/auth-layout';
import { useAuth } from '@/lib/auth-context';

export default function SignInPage() {
  const router = useRouter();
  const { signIn } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setError(null);
    if (!email || !password) {
      setError('Ingresa tu correo y contraseña.');
      return;
    }
    setLoading(true);
    try {
      await signIn(email, password);
      router.push('/mi-estanteria');
    } catch {
      setError('No pudimos iniciar tu sesión. Revisa tus datos.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayout
      eyebrow="Bienvenido"
      title="Inicia sesión"
      intro="Accede para tomar libros prestados, gestionar tus lecturas y guardar tus favoritos."
      footer={
        <>
          ¿Aún no tienes cuenta?{' '}
          <Link href="/crear-cuenta" className="under" style={{ color: 'var(--ink)', fontWeight: 500 }}>
            Crea una gratis
          </Link>
        </>
      }
    >
      <form onSubmit={onSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
        <label>
          <div className="eyebrow" style={{ marginBottom: 6 }}>Correo electrónico</div>
          <input
            className="input"
            type="email"
            autoComplete="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="tu.correo@dominio.mx"
            required
          />
        </label>
        <label>
          <div className="eyebrow" style={{ marginBottom: 6 }}>Contraseña</div>
          <input
            className="input"
            type="password"
            autoComplete="current-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </label>

        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontSize: 13 }}>
          <Link href="/recuperar-contrasena" className="under" style={{ color: 'var(--ink-soft)' }}>
            Olvidé mi contraseña
          </Link>
        </div>

        {error && <div style={{ color: 'var(--accent)', fontSize: 13 }}>{error}</div>}

        <button type="submit" className="btn btn-primary" disabled={loading} style={{ justifyContent: 'center', marginTop: 8 }}>
          {loading ? 'Entrando…' : 'Entrar'}
        </button>
      </form>
    </AuthLayout>
  );
}
